import * as actionTypes from '../config/actionTypes';

import * as profileFormStates from './utils/profileFormStates';
import * as constants from "../config/constants";


const initialState = {
  loading: false,
  hasError: false,
  basicinfo: profileFormStates.accountinfo,
  personalinfo: profileFormStates.personalinfo,
  lifestyleinfo: profileFormStates.lifestyleinfo,
  educationinfo: profileFormStates.educationinfo,
  familyinfo: profileFormStates.familyinfo,
  contactinfo: profileFormStates.contactinfo,
  referenceinfo: profileFormStates.referenceinfo,
  photos: profileFormStates.fileupload,
  pdfs: profileFormStates.fileupload,
  idproof: profileFormStates.idupload,
  idproofaadhar: profileFormStates.iduploadaadhar,
  report: profileFormStates.report,
  partnerchoice: profileFormStates.partnerchoice,
  files: [],
  errors: [],
  profile_id: null,
  site_settings: null,
  profile_state: null,
  error: null,
  success: null,
  deleteProfile: profileFormStates.deleteProfile,
  hideBranchField: false,
};

const toggleLoadingReducer = (state) => {
  return {
    ...state,
    loading: !state.loading,
  };
};


const toggleErrorReducer = (state) => {
  return {
    ...state,
    hasError: !state.hasError,
  };
};


const updateProfileInputReducer = (state, payload) => {
  console.log('reducers===state',state);
  console.log('reducers===payload',payload);

  let section = payload.section
  if (section==='idproof'){
    const userData=JSON.parse(localStorage.getItem('user'))
    let site = constants.INDIAN_SITES.find(site=>site[0]===userData.site.url)
    if (site){
      section='idproofaadhar'
    }
  }

  const data = {
    ...state[section],
    ...payload.data,
  };
  if (section === 'basicinfo') {
    if (state.hideBranchField) {
      data.bureau.valid = true;
      data.bureau.touched = true;
    }
  }

  if (section === 'personalinfo'
      && data.marital_status.value.value !== 5
      && data.marital_status.value.value !== 6
  ) {
    data.marriage_end_year.value = '-';
    data.marriage_end_year.valid = true;
    data.marriage_end_year.touched = true;

    data.marriage_years_count.value = '-';
    data.marriage_years_count.valid = true;
    data.marriage_years_count.touched = true;

    data.children.value = '-';
    data.children.valid = true;
    data.children.touched = true;

    data.legal.value = '-';
    data.legal.valid = true;
    data.legal.touched = true;
  }

  if (section === 'personalinfo'
      && (data.marital_status.value.value === 5
          || data.marital_status.value.value === 6)
  ) {
    if (data.marriage_end_year.value === '-') {
      data.marriage_end_year.value = '';
      data.marriage_end_year.valid = false;
      data.marriage_end_year.touched = false;
    }

    if (data.marriage_years_count.value === '-') {
      data.marriage_years_count.value = '';
      data.marriage_years_count.valid = false;
      data.marriage_years_count.touched = false;
    }

    if (data.children.value === '-') {
      data.children.value = '';
      data.children.valid = false;
      data.children.touched = false;
    }

    if (data.legal.value === '-') {
      data.legal.value = '';
      data.legal.valid = false;
      data.legal.touched = false;
    }
  }

  return {
    ...state,
    [section]: {
      ...data,
    },
  };
};


const updateFilesReducer = (state, payload) => {
  return {
    ...state,
    files: [...payload],
  };
};


const updateErrorsReducer = (state, payload) => {
  return {
    ...state,
    errors: [...payload],
  };
};

const profileUnmountReducer = () => {
  return {
    ...initialState,
  };
};


const showProfileStatusReducer = (state, payload) => {
  return {
    ...state,
    profile_id: payload.profile_id,
    site_settings: payload.site_settings,
    profile_state: payload.profile_state,
  };
};


const showProfileErrorReducer = (state, payload) => {
  return {
    ...state,
    error: payload,
  };
};


const showProfileReducer = (state, payload) => {
  return {
    ...state,
    profile: payload,
  };
};


const showSuccessMsgReducer = (state, payload) => {
  return {
    ...state,
    success: payload,
  };
};

const updateBranchFieldStatusReducer = (state, payload) => {
  return {
    ...state,
    hideBranchField: payload.value,
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_PROFILE_LOADING: return toggleLoadingReducer(state);
    case actionTypes.TOGGLE_PROFILE_ERROR: return toggleErrorReducer(state);
    case actionTypes.UPDATE_PROFILE_INPUTS: return updateProfileInputReducer(state, action.payload);
    case actionTypes.UPDATE_FILES: return updateFilesReducer(state, action.payload);
    case actionTypes.UPDATE_PROFILE_ERRORS: return updateErrorsReducer(state, action.payload);
    case actionTypes.PROFILE_UNMOUNT: return profileUnmountReducer();
    case actionTypes.SHOW_PROFILE_STATUS: return showProfileStatusReducer(state, action.payload);
    case actionTypes.SHOW_PROFILE_ERROR: return showProfileErrorReducer(state, action.payload);
    case actionTypes.SHOW_PROFILE: return showProfileReducer(state, action.payload);
    case actionTypes.SHOW_SUCCESS_MESSAGE: return showSuccessMsgReducer(state, action.payload);
    case actionTypes.UPDATE_BRANCH_FIELD_STATUS: return updateBranchFieldStatusReducer(
      state, action.payload,
    );
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/reducers.js